<app-details-panel-shell
  [visible]="visible"
  [title]="title"
  [showEditButton]="showEditButton"
  (onClose)="close()"
  (onEdit)="edit()"
>
  <!-- Data Tab -->
  <div class="data-tab">
    <ng-container
      *ngIf="componentDetails && componentDetails.length > 0; else noDetails"
    >
      <div *ngFor="let detail of componentDetails" class="sort">
        <div class="data-item">
          <div class="field-label" i18n="@@model">Model</div>
          <div>{{ detail.model }}</div>
        </div>
        <div class="data-item">
          <div class="field-label" i18n="@@manufacturer">Manufacturer</div>
          <div>{{ detail.manufacturerName }}</div>
        </div>
        <div class="data-item">
          <div class="field-label" i18n="@@type">Type</div>
          <div>{{ detail.type }}</div>
        </div>
        <div class="data-item">
          <div class="field-label" i18n="@@status">Status</div>
          <app-status-pill
            *ngIf="detail.status && getStatusId(detail.status)"
            [statusId]="getStatusId(detail.status)"
            [statusConfig]="contractStatusConfig"
          ></app-status-pill>
        </div>
        <ng-container
          *ngIf="detail.dataFields && detail.dataFields.length > 0"
        >
          <ng-container *ngFor="let field of detail.dataFields">
            <div class="data-item">
              <div class="field-label">{{ field.fieldName }}</div>
              <div>{{ field.value === "" ? "n/a" : field.value }}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noDetails>
      <span i18n="@@noDetails">No details available.</span>
    </ng-template>
  </div>

  <!-- Documents Tab -->
  <div class="doc-tab" *ngIf="getFilteredDoclinks().length > 0">
    <div class="header">
      <span style="font-weight: 500" i18n="@@documents">Documents</span>
      <app-gpd-button
        *ngIf="showDownloadAllButton"
        i18n-text="@@downloadAll"
        text="Download All"
        icon="download"
        type="text"
        (onClick)="downloadAll()"
        [disabled]="disableDownloadAll"
      ></app-gpd-button>
    </div>
    <div class="document-container">
      <ng-container *ngFor="let doc of getFilteredDoclinks()">
        <app-contracts-pill
          [content]="{
            docLink: doc.docLink,
            docName: getDocTypeName(doc.docId),
          }"
          [linkType]="'techDocument'"
          [displayString]="getDocTypeName(doc.docId)"
          icon="doc"
        ></app-contracts-pill>
      </ng-container>
    </div>
  </div>

  <!-- Sites Tab -->
  <div class="site-tab" *ngIf="filteredSiteIds && filteredSiteIds.length > 0">
    <div class="header">
      <span style="font-weight: 500" i18n="@@site">Site</span>
    </div>
    <div class="pill-container">
      <ng-container *ngFor="let siteId of filteredSiteIds; let i = index">
        <app-contracts-pill
          [content]="{ siteId: siteId, siteName: filteredSiteNames[i] }"
          [linkType]="'techSite'"
          [displayString]="filteredSiteNames[i]"
          [quantity]="filteredSiteQuantities[i]"
        ></app-contracts-pill>
      </ng-container>
    </div>
  </div>

  <!-- Projects Tab -->
  <div
    class="site-tab"
    *ngIf="filteredProjectIds && filteredProjectIds.length > 0"
  >
    <div class="header">
      <span style="font-weight: 500" i18n="@@projects">Projects</span>
    </div>
    <div class="pill-container">
      <ng-container *ngFor="let projectId of filteredProjectIds; let i = index">
        <app-contracts-pill
          [content]="{
            projectId: projectId,
            projectName: filteredProjectNames[i],
            siteId: filteredProjectSiteIds[i],
          }"
          [linkType]="'techProject'"
          [displayString]="filteredProjectNames[i]"
          [quantity]="filteredProjectQuantities[i]"
          [projectStatus]="filteredProjectStatuses[i]"
        ></app-contracts-pill>
      </ng-container>
    </div>
  </div>
</app-details-panel-shell>
